<template>
    <div class="d-inline">
        <span :id='id' class="svg-icon svg-icon-primary">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <rect x="0" y="0" width="24" height="24"></rect>
                    <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"></circle>
                    <rect fill="#000000" x="11" y="10" width="2" height="7" rx="1"></rect>
                    <rect fill="#000000" x="11" y="7" width="2" height="2" rx="1"></rect>
                </g>
            </svg>        
        </span>
        <b-tooltip :target="id" triggers="hover">
            <strong>Hashtag Performance Campaigns</strong> allow you to monitor <code>per-hashtag performance</code> for your accounts, so you can easily identify which hashtags performed the best and which ones you should change!
        </b-tooltip>
    </div>
</template>

<script>
export default {
    name: "HashtagPerformanceTooltip",
    props: ['id']
}
</script>